import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState } from 'react';
import { ExpandableTagGroup as ExpandableTagGroup$2, TagList, TagListItem } from './ExpandableTagGroup.style.js';
import Tag from '../Tag/Tag.js';
import ExpandableLink from '../Link/ExpandableLink.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ExpandableTagGroup = function ExpandableTagGroup(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    _ref$nrOfVisibleItems = _ref.nrOfVisibleItems,
    nrOfVisibleItems = _ref$nrOfVisibleItems === void 0 ? 6 : _ref$nrOfVisibleItems,
    tags = _ref.tags,
    _ref$tagProps = _ref.tagProps,
    tagProps = _ref$tagProps === void 0 ? null : _ref$tagProps,
    _ref$buttonLabel = _ref.buttonLabel,
    buttonLabel = _ref$buttonLabel === void 0 ? 'Visa fler' : _ref$buttonLabel,
    _ref$buttonLabelExpan = _ref.buttonLabelExpanded,
    buttonLabelExpanded = _ref$buttonLabelExpan === void 0 ? 'Visa färre' : _ref$buttonLabelExpan;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var handleToggleExpanded = function handleToggleExpanded() {
    setIsExpanded(!isExpanded);
  };
  if (tags.length === 0) {
    return undefined;
  }
  var initialList = tags.slice(0, nrOfVisibleItems);
  var toggleableList = tags.slice(nrOfVisibleItems);
  var expandButtonText = isExpanded ? buttonLabelExpanded : buttonLabel;
  return /*#__PURE__*/jsx(ExpandableTagGroup$2, {
    className: className,
    children: /*#__PURE__*/jsxs(TagList, {
      $isExpanded: isExpanded,
      children: [initialList.map(function (tag) {
        return /*#__PURE__*/jsx(Tag, _objectSpread(_objectSpread({
          as: "li"
        }, tagProps), {}, {
          children: tag
        }), tag);
      }), toggleableList.length > 0 && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(TagListItem, {
          $displayLast: isExpanded,
          children: /*#__PURE__*/jsx(ExpandableLink, {
            isOpen: isExpanded,
            onClick: handleToggleExpanded,
            children: expandButtonText
          })
        }), toggleableList.map(function (tag) {
          return /*#__PURE__*/jsx(Tag, _objectSpread(_objectSpread({
            as: "li"
          }, tagProps), {}, {
            className: "tag-list__toggleable-item",
            children: tag
          }), tag);
        })]
      })]
    })
  });
};
var ExpandableTagGroup$1 = ExpandableTagGroup;

export { ExpandableTagGroup$1 as default };
//# sourceMappingURL=ExpandableTagGroup.js.map
